import console from 'console';

const BILL_DURATION_FROM = 10; // only count calls having billDuration >= 10 (seconds)

export async function countSuccessCall($service, userId, startTime, endTime) {
  try {
    if (typeof startTime !== 'number') throw new TypeError('startTime must be a number');
    if (typeof endTime !== 'number') throw new TypeError('endTime must be a number');

    const response = await $service.get('/call', {
      params: {
        from: startTime,
        to: endTime,
        direction: 'outbound',
        billDurationFrom: BILL_DURATION_FROM,
        user: userId,
      },
    });
    return response.data.totalDocs;
  } catch (error) {
    console.error(error); // let's output the error silently
  }
}

export async function getGroupName($service) {
  const response = await $service.get('/profile/group');
  return response.data.name;
}
